import { render, staticRenderFns } from "./EditStorage.vue?vue&type=template&id=699280f4"
import script from "./EditStorage.vue?vue&type=script&lang=js"
export * from "./EditStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports